//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../Tooling/Tooling.DieDesPlaneListBuilderList.js";
import "../no/SelectPointList.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AngTolerance",1,0],[1,"BackPlanes",0,"Tooling.DieDesPlaneListBuilderList",0],[0,"BasePlane",1,"Plane",0],[1,"BoltPoints",0,"SelectPointList",0],[0,"CamDirection",1,"Direction",0],[0,"CreateSheetBody",1,0],[0,"DisTolerance",1,0],[1,"DowelPoints",0,"SelectPointList",0],[0,"EndPlane",1,"Plane",0],[0,"EndRelief",1,0],[1,"LiftPoints",0,"SelectPointList",0],[1,"LwCutterEntrLaw",0,"GeometricUtilities.LawBuilder",0],[1,"Product",0,"SelectBody",0],[1,"Profiles",0,"ScCollector",0],[0,"ProfilesDirection",1,0],[1,"PushPinPoints",0,"SelectPointList",0],[1,"RibPlanes",0,"Tooling.DieDesPlaneListBuilderList",0],[0,"ScrapCutterDesType",1,0],[0,"StartPlane",1,"Plane",0],[0,"StartRelief",1,0],[1,"SteelEntranceLaw",0,"GeometricUtilities.LawBuilder",0],[0,"SyncLwScapCutter",1,0]],[],[]];
SPLM.Tooling.DieDesTrmStlFeatBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesTrmStlFeatBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieDesTrmStlFeatBuilder.ScrapCutterDesTypes = Object.freeze({
    "NoneNoBypass" : "NoneNoBypass", "NoneStartBypass" : "NoneStartBypass", "NoneEndBypass" : "NoneEndBypass", "NoneBothBypass" : "NoneBothBypass", "StartNoEndBypass" : "StartNoEndBypass", "StartEndBypass" : "StartEndBypass", "EndNoStartBypass" : "EndNoStartBypass", "EndStartBypass" : "EndStartBypass", "BothNoBypass" : "BothNoBypass"});

export default SPLM;